export enum IdPParamKeys {
  UserSub = '{{userSub}}',
  ManagementGroupId = '{{managementGroupId}}',
}
